<template>
  <footer>
    <BContainer fluid class="p-3" style="background-color: #1c1c1c;">
      <BRow no-gutters class="w-100">
          <BCol class="d-flex justify-content-center">                                 
              <p class="mb-0 text-right">
                © Copyright 2024 Password rubata. All Rights Reserved. Servizio offerto da
                  <a href="https://comedifendersidaglihacker.com/" target="_blank" class="text-info ml-2"> ComeDifendersiDagliHacker.com</a>
              </p>
          </BCol>
      </BRow>
  </BContainer>
  </footer>
</template>